var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGiftMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_15354",
    "data-name": "Group 15354",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 13.285,
    height: 14.304,
    viewBox: "0 0 13.285 14.304",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5341",
    "data-name": "Rectangle 5341",
    width: 13.285,
    height: 14.304,
    fill: "#faf8f8"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15353",
    "data-name": "Group 15353",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29460",
    "data-name": "Path 29460",
    d: "M3.579,0a1.974,1.974,0,0,0-1.8,1.048A2.193,2.193,0,0,0,1.546,2,2.046,2.046,0,0,0,1.89,3.344a2.082,2.082,0,0,0,.183.232H.514a.488.488,0,0,0-.362.149A.5.5,0,0,0,0,4.087V7.149a.514.514,0,0,0,.514.514H1.535v6.13a.515.515,0,0,0,.511.511h9.2a.51.51,0,0,0,.508-.511V7.663h1.024a.509.509,0,0,0,.511-.514V4.087a.509.509,0,0,0-.511-.511H11.215a2.43,2.43,0,0,0,.181-.232A2.011,2.011,0,0,0,11.739,2a2.148,2.148,0,0,0-.234-.95A1.97,1.97,0,0,0,9.706,0a2.292,2.292,0,0,0-1.62.71A4.338,4.338,0,0,0,7.2,2.1a7.376,7.376,0,0,0-.46,1.479H6.551A7.56,7.56,0,0,0,6.091,2.1,4.385,4.385,0,0,0,5.2.71,2.3,2.3,0,0,0,3.579,0m0,1.022a1.2,1.2,0,0,1,.9.407A3.5,3.5,0,0,1,5.152,2.5,4.079,4.079,0,0,1,5.46,3.576H5.111c-1.578-.011-2.137-.455-2.373-.8a.991.991,0,0,1-.189-.655.326.326,0,0,0,.008-.074,1.433,1.433,0,0,1,.136-.54c.131-.261.29-.482.886-.482m6.128,0c.6,0,.755.221.886.482a1.433,1.433,0,0,1,.136.54c0,.027.005.05.008.074a.978.978,0,0,1-.187.655c-.236.349-.8.793-2.373.8H7.825A4.283,4.283,0,0,1,8.134,2.5,3.494,3.494,0,0,1,8.81,1.429a1.2,1.2,0,0,1,.9-.407M1.024,4.6H5.111V6.641H1.024Zm5.109,0H7.155V6.641H6.133Zm2.043,0h4.087V6.641H8.177ZM2.557,7.663H5.111v5.619H2.557Zm3.576,0H7.155v5.619H6.133Zm2.043,0h2.552v5.619H8.177Z",
    fill: "#faf8f8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftMenuIcon);
export default __webpack_public_path__ + "static/media/gift-menu-icon.b622cf634a239bec1342a6682dffb628.svg";
export { ForwardRef as ReactComponent };